import { StepProps } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';

import { navigate } from '~/b4b/utils/pathHelpers';

export const SuccessStep: React.FC<StepProps> = ({ flowState }) => {
  return <SuccessFullScreen message="Generating report" onCompletion={() => navigate(flowState.returnToPath)} />;
};
